import { zatochka, accum, trash } from '@images';
import type { PrepareGiftToSelectReturnType } from '@utils/orderUtils/prepareGiftToSelect';

interface CartGiftItem {
  id?: number | null;
  [key: string]: any;
}

interface CartPromoCodeItem {
  promoCode?: {
    product?: { id?: number | null } | null;
    giftItem?: { id?: number | null } | null;
  } | null;
}

interface CartLike {
  gifts?: CartGiftItem[] | null;
  promoCodes?: CartPromoCodeItem[] | null;
  cartTestDrive?: {
    product?: { id?: number | null } | null;
  } | null;
}

const getGiftServiceImage = (serviceId: number | null | undefined): string => {
  if (serviceId === 8 || serviceId === 12) {
    return zatochka.x3;
  }
  if (serviceId === 3) {
    return accum.x3;
  }
  return trash.x3;
};

const buildCartGifts = ({
  cart,
  giftToSelect
}: {
  cart: CartLike | null | undefined;
  giftToSelect: PrepareGiftToSelectReturnType;
}): Array<Record<string, any>> => {
  const testDriveProductId = cart?.cartTestDrive?.product?.id;
  const promoCodes = cart?.promoCodes;

  const autoGifts = (cart?.gifts || [])
    .filter(item => {
      const promoMatchedItem = promoCodes?.find(
        i => i?.promoCode?.product && i?.promoCode?.giftItem?.id === item?.id
      );
      return item?.id !== testDriveProductId && !promoMatchedItem;
    })
    .map(item => ({ isAutoGift: true, ...item }));

  const serviceGifts = giftToSelect.uniqueServices.map(service => ({
    isService: true,
    mainImage: getGiftServiceImage(service.id),
    ...service
  }));

  const activeGiftId = giftToSelect.activeGift?.[0]?.id;

  return [...autoGifts, ...giftToSelect.uniqueProducts, ...serviceGifts].map(
    gift => ({
      isGiftInCart: activeGiftId !== undefined && activeGiftId === gift.id,
      ...gift
    })
  );
};

export default buildCartGifts;
